<template>
  <div class="appeal-container">
    <div class="main-container">
      <div class="main">
        <div class="guidance">
          <div class="title">侵权申诉指引</div>
          <div class="content">
            <p>
              衣创社区作为中立的网络服务提供者，仅为用户提供信息存储空间。衣创社区用户自行在衣创社区注册，并发布内容、提供商品或服务，衣创社区无法对用户的侵权情况事前审
              核，不对用户在平台上发布的内容提供任何形式的保证。
            </p>

            <p>
              衣创社区为帮助您维护自身合法权益，制定并向您提供本指引，请您详细阅读。您如果认为衣创社区中的用户、笔记、商品、直播等存在侵犯您合法权益的内容，请按照本指引
              填写表格衣向创社区提交您的投诉。
            </p>
            <p>
              <span>*请您务必知悉，</span
              >侵权投诉是一项严肃的法律行为，衣创社区严格按照《民法典》、《电子商务法》、《信息网络传播权保护条例》等相关法律法规有关规定审核、处理您的侵
              权投诉，如果您未能按照本指引中所示要求行使您的权利，您的侵权投诉将无法被受理。
            </p>
          </div>
        </div>
        <div class="appeal-form">
          <div class="form-title">侵权申诉表</div>
          <div class="form-group-title">权利人基本信息</div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">权利人姓名/名称:</div>
              <input v-model="form.name" placeholder="请输入权利人姓名/名称" />
            </div>
            <div class="form-item">
              <div class="form-item-label required">权利人身份证号码:</div>
              <input
                v-model="form.id_no"
                placeholder="请输入权利人身份证号码"
              />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">联系电话:</div>
              <input v-model="form.phone" placeholder="请输入联系电话号码" />
            </div>
            <div class="form-item">
              <div class="form-item-label required">联系邮箱:</div>
              <input v-model="form.email" placeholder="请输入联系邮箱" />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">联系地址:</div>
              <input
                v-model="form.address"
                placeholder="请输入详细的联系地址"
              />
            </div>
          </div>
          <div class="form-group-title">投诉事实及理由</div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">投诉内容</div>
              <div class="input-group">
                <input v-model="form.author_name" placeholder="发布者名称" />
                <input v-model="form.post_title" placeholder="笔记标题" />
                <input v-model="form.post_url" placeholder="笔记链接地址" />
              </div>
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">投诉案由</div>
              <div class="reason-box">
                <div class="reason-item">
                  <div class="reason-label">自然人权益(可多选)</div>
                  <div class="reason-check-box" style="margin-left: 39px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('名誉中伤')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('名誉中伤')"
                        @click="onReasonClick('名誉中伤')"
                      />
                      <Icon
                        @click="onReasonClick('名誉中伤')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>名誉中伤</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('肖像权、隐私泄露')"
                        type="checkbox"
                        :checked="
                          form.appeal_reason.includes('肖像权、隐私泄露')
                        "
                        @click="onReasonClick('肖像权、隐私泄露')"
                      />
                      <Icon
                        @click="onReasonClick('肖像权、隐私泄露')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>肖像权、隐私泄露</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('假冒个人账号')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('假冒个人账号')"
                        @click="onReasonClick('假冒个人账号')"
                      />
                      <Icon
                        @click="onReasonClick('假冒个人账号')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>假冒个人账号</span>
                    </div>
                  </div>
                </div>
                <div class="reason-item">
                  <div class="reason-label">知识产权侵权(可多选)</div>
                  <div class="reason-check-box" style="margin-left: 25px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('商标侵权')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('商标侵权')"
                        @click="onReasonClick('商标侵权')"
                      />
                      <Icon
                        @click="onReasonClick('商标侵权')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>商标侵权</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('著作权侵权')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('著作权侵权')"
                        @click="onReasonClick('著作权侵权')"
                      />
                      <Icon
                        @click="onReasonClick('著作权侵权')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>著作权侵权</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('专利侵权')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('专利侵权')"
                        @click="onReasonClick('专利侵权')"
                      />
                      <Icon
                        @click="onReasonClick('专利侵权')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>专利侵权</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('商业秘密')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('商业秘密')"
                        @click="onReasonClick('商业秘密')"
                      />
                      <Icon
                        @click="onReasonClick('商业秘密')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>商业秘密</span>
                    </div>
                  </div>
                </div>
                <div class="reason-item">
                  <div class="reason-label">其它企业权益</div>
                  <div class="reason-check-box" style="margin-left: 76px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('商誉诋毁')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('商誉诋毁')"
                        @click="onReasonClick('商誉诋毁')"
                      />
                      <Icon
                        @click="onReasonClick('商誉诋毁')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>商誉诋毁</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('假冒企业身份')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('假冒企业身份')"
                        @click="onReasonClick('假冒企业身份')"
                      />
                      <Icon
                        @click="onReasonClick('假冒企业身份')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>假冒企业身份</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group-title" style="margin-bottom: 15px">
            投诉侵权事实及证明材料
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="desc require">
                请将能够证明侵权事实的证明图片或材料以文件形式上传
              </div>
              <!-- :format="['jpg', 'jpeg', 'png', 'gif']"
                accept=".jpg,.jpeg,.png,.gif" -->
              <Upload
                class="img-upload-btn"
                :action="upload_url"
                :data="{ dir: 'template' }"
                multiple
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'img_list')
                "
                :show-upload-list="false"
              >
                <template>
                  <div class="up-btn">
                    <Icon type="md-add" size="32" color="#ffffff"></Icon>
                    <div class="upbtn-text">上传证明文件</div>
                  </div>
                </template>
              </Upload>
              <div class="file-list-box">
                <div
                  class="list-item"
                  v-for="(item, index) in form.file_list"
                  :key="index"
                >
                  <div class="item-box">
                    <div class="left">
                      <img
                        class="icon"
                        src="../../assets/images/icon-file.png"
                      />
                      <div class="file-name">{{ item.file_name }}</div>
                    </div>
                    <div class="right" @click="onRemoveFile(index)">
                      <Icon type="md-close-circle" size="26"></Icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">侵权事实说明</div>
              <textarea v-model="form.appeal_introduction" placeholder="请输入侵权事实说明"></textarea>
            </div>
          </div>
          <div class="form-group-title" style="margin-bottom: 21px">
            保证声明
          </div>
          <p>权利人（统称为：声明人）诚意作如下保证声明：</p>
          <p>
            声明人在申述表中的陈述和提供的相关材料皆是真实、有效和合法的，由于此申述表及相关材料引起的一切后果皆由声明人承担。声明人保证承担和赔偿，因衣创社区根据声明人的
            申述表而删除有关内容或者断开有关服务或内容的链接而给衣创社区造成的全部损失，包括但不限于衣创社区因向被投诉方或用户赔偿而产生的损失及衣创社区名誉、商誉损害等。
          </p>
          <div class="agreement">
            <input type="checkbox" v-model="is_agree" />
            我已阅读并同意保证声明内容
          </div>
        </div>
        <div class="btn-box">
          <button @click="$router.back()">取消</button>
          <button @click="onSubmit">提交申诉</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SubmitAppeal } from "@/api/social";
export default {
  data() {
    return {
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      form: {
        name: "",
        id_no: "",
        phone: "",
        email: "",
        address: "",
        author_name: "",
        post_title: "",
        post_url: "",
        appeal_reason: [],
        file_list: [],
        appeal_introduction: "",
      },
      is_agree: false,
    };
  },
  mounted() {},
  methods: {
    async onSubmit() {
      try {
        const { form, is_agree } = this;
        if (!is_agree) {
          this.$layer.msg("请先同意保证声明内容");
          return;
        }
        const { code, msg } = await SubmitAppeal(form);
        if (code > 0) {
          this.$layer.msg(msg);
        }else {
          this.$layer.msg("提交成功,请耐心等待审核");
          this.$router.push({name:'SubmitResult'});
          this.form = {
            name: "",
            id_no: "",
            phone: "",
            email: "",
            address: "",
            author_name: "",
            post_title: "",
            post_url: "",
            appeal_reason: [],
            file_list: [],
            appeal_introduction: "",
          }
        }
      } catch (e) {
        console.log("e", e);
        this.$layer.msg(e.msg);
      }
    },
    onRemoveFile(index) {
      this.form.file_list.splice(index, 1);
    },
    onReasonClick(data) {
      const index = this.form.appeal_reason.indexOf(data);
      if (index > -1) {
        // 如果已存在，则移除
        this.form.appeal_reason.splice(index, 1);
      } else {
        // 如果不存在，则推入
        this.form.appeal_reason.push(data);
      }
      console.log("form_appeal_reason", this.form);
    },
    handleSuccess(response, file, fileList, field) {
      console.log("response", response);
      console.log("file", file);
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')+1).toLowerCase();
      this.form.file_list.push({
        file_name: file.name,
        url: response.data.url,
        file_type:fileExtension
      });
      console.log('form',this.form.file_list);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./appeal.scss";
</style>
